import PropTypes from 'prop-types'
import React from 'react'
import { Tabs } from 'react-wot-bootstrap'

import { toRoman } from 'helpers'
import { SORTIES_WITH_LEVEL, FORT_BATTLES } from 'helpers/i18n'

import LevelFilterTooltip from '../LevelFilterTooltip/LevelFilterTooltip'

import {
    UNIT_TYPES,
    BATTLE_ROOMS_TAB_STATES,
} from 'constants'

export class BattleModeFilter extends React.Component {
    static propTypes = {
        tab: PropTypes.oneOf(Object.values(BATTLE_ROOMS_TAB_STATES)).isRequired,
        selectedUnitType: PropTypes.string,
        selectedVehicleLevel: PropTypes.number,

        battleModesSettings: PropTypes.arrayOf(PropTypes.shape({
            unit_type: PropTypes.oneOf(Object.keys(UNIT_TYPES)),
            min_players_number: PropTypes.number,
            max_players_number: PropTypes.number,
            max_vehicle_level: PropTypes.number,
            max_legionaries_number: PropTypes.number,
            battle_duration: PropTypes.number,
        })),

        /**
         * method that is called when tab is changed
         * @param {UNIT_TYPES} unitType of selected tab
         * @param {(int|undefined)} vehicleLevel of selected tab. undefined for fort battles
         */
        onChange: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.generateTabsItems = this.generateTabsItems.bind(this)
        this.getCheckedItem = this.getCheckedItem.bind(this)
        this.onTabChange = this.onTabChange.bind(this)
    }

    generateTabsItems() {
        return this.props.battleModesSettings.map(setting => {
            if (setting.unit_type === UNIT_TYPES.SORTIE) {
                return {
                    value: getTabValue(setting.unit_type, setting.max_vehicle_level),
                    caption: SORTIES_WITH_LEVEL(toRoman(setting.max_vehicle_level)),
                    tooltipId: getTooltipId(setting),
                }
            }

            return {
                value: getTabValue(setting.unit_type, setting.max_vehicle_level),
                caption: FORT_BATTLES,
                tooltipId: getTooltipId(setting),
            }
        })
    }

    getCheckedItem() {
        return getTabValue(this.props.selectedUnitType, this.props.selectedVehicleLevel)
    }

    onTabChange(value) {
        const selectedSetting = this.props.battleModesSettings.find(
            setting => getTabValue(setting.unit_type, setting.max_vehicle_level) === value
        )

        this.props.onChange(selectedSetting.unit_type, selectedSetting.max_vehicle_level)
    }

    renderTooltips() {
        return this.props.battleModesSettings.map(setting => (
            <LevelFilterTooltip
                id={getTooltipId(setting)}
                key={setting.unit_type + setting.max_vehicle_level}
                battleRegulations={setting}
                tab={this.props.tab}
            />
        ))
    }

    render() {
        const TAB_COUNT = this.props.battleModesSettings.length
        const MIN_TABS_WIDTH = 350 // react-wot-boostrap style
        // 1/4 of UnitsView div.main width(560px) if you have less than 5 tabs
        const TAB_WIDTH = TAB_COUNT < 5 ? 140 : 560 / TAB_COUNT
        const width = Math.max(TAB_WIDTH * TAB_COUNT, MIN_TABS_WIDTH)

        return (
            <div style={{ width: width + 'px' }}>
                <Tabs
                    items={this.generateTabsItems()}
                    checkedItem={this.getCheckedItem()}
                    onItemChange={this.onTabChange}
                />
                {this.renderTooltips()}
            </div>
        )
    }
}

function getTabValue(unit_type, vehicle_level) {
    return unit_type + '_' + vehicle_level
}

function getTooltipId({ unit_type, max_vehicle_level }) {
    return `battleModeFilterTooltip_${unit_type}_${max_vehicle_level}`
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleModeFilter/BattleModeFilter.jsx